import {userActionTypes} from "./actionTypes";

export function setLanguage(payload) {
    return {
        type: userActionTypes.SET_LANGUAGE,
        payload: payload
    }
}